import { i as e, r as t, t as n } from "./temporal.utils-BPbaTNbS.js";
import { $ as r, F as i, L as a, S as o, _ as s, h as c, i as l, m as u, nt as d, ot as f, p, rt as m, t as h, v as g, w as _ } from "./_plugin-vue_export-helper-CTQVpqU-.js";
import { t as v } from "./normalize-props-DNjMoRjC.js";
import { i as y, n as b, t as x } from "./i18n-1IaTix1m.js";
//#region src/webcomponents/select-conversation/locales/de-AT.json
var S = {}, C = {}, w = {}, T = {}, E = {}, D = { "select-conversation": {
	"select-response-title": "Sélectionnez le message que {{username}} devrait envoyer\xA0:",
	"message-date": "{{messageDay, relativetime(numeric: auto)}} · {{messageTime, datetime(timeStyle: short)}}",
	"incoming-message-sr": "Message de {{username}} reçu {{messageDay, relativetime(numeric: auto)}} à {{messageTime, datetime(timeStyle: short)}}",
	"outgoing-message-sr": "Message envoyé par {{username}} {{messageDay, relativetime(numeric: auto)}} à {{messageTime, datetime(timeStyle: short)}}",
	"good-idea": "Bonne idée",
	"bad-idea": "Mauvaise idée"
} }, O = {}, k = {}, A = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%20448%20512'%3e%3c!--!Font%20Awesome%20Free%20v7.1.0%20by%20@fontawesome%20-%20https://fontawesome.com%20License%20-%20https://fontawesome.com/license/free%20Copyright%202025%20Fonticons,%20Inc.--%3e%3cpath%20d='M434.8%2070.1c14.3%2010.4%2017.5%2030.4%207.1%2044.7l-256%20352c-5.5%207.6-14%2012.3-23.4%2013.1s-18.5-2.7-25.1-9.3l-128-128c-12.5-12.5-12.5-32.8%200-45.3s32.8-12.5%2045.3%200l101.5%20101.5%20234-321.7c10.4-14.3%2030.4-17.5%2044.7-7.1z'/%3e%3c/svg%3e", j = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%20512%20512'%3e%3c!--!Font%20Awesome%20Free%20v7.1.0%20by%20@fontawesome%20-%20https://fontawesome.com%20License%20-%20https://fontawesome.com/license/free%20Copyright%202025%20Fonticons,%20Inc.--%3e%3cpath%20d='M256%2048a208%20208%200%201%201%200%20416%20208%20208%200%201%201%200-416zm0%20464a256%20256%200%201%200%200-512%20256%20256%200%201%200%200%20512zM167%20167c-9.4%209.4-9.4%2024.6%200%2033.9l55%2055-55%2055c-9.4%209.4-9.4%2024.6%200%2033.9s24.6%209.4%2033.9%200l55-55%2055%2055c9.4%209.4%2024.6%209.4%2033.9%200s9.4-24.6%200-33.9l-55-55%2055-55c9.4-9.4%209.4-24.6%200-33.9s-24.6-9.4-33.9%200l-55%2055-55-55c-9.4-9.4-24.6-9.4-33.9%200z'/%3e%3c/svg%3e", M = { class: "messages" }, N = { class: "message" }, P = {
	class: "message__username",
	"aria-hidden": "true"
}, F = { class: "sr-only" }, I = { class: "message__content" }, L = {
	class: "message__date",
	"aria-hidden": "true"
}, R = ["aria-hidden"], z = {
	class: "message__username",
	"aria-hidden": "true"
}, B = { class: "sr-only" }, V = { class: "message__content-container" }, H = { class: "message__content-title" }, U = ["src"], W = { class: "message__content" }, G = {
	class: "message__date",
	"aria-hidden": "true"
}, K = { class: "response-select" }, q = ["aria-level"], J = { class: "response-select__choices" }, Y = ["aria-disabled", "onClick"], X = { "aria-live": "polite" }, Z = ["innerHTML"], Q = /*#__PURE__*/ h(/* @__PURE__ */ _({
	__name: "SelectConversation.ce",
	props: {
		titleLevel: {
			default: 2,
			type: Number
		},
		incomingMessage: { type: Object },
		username: { type: String },
		responseChoices: { type: Array }
	},
	setup(l, { expose: h }) {
		let _ = r(l.responseChoices.map((e) => ({
			...e,
			selected: !1
		}))), v = r(), y = u(() => n(l.incomingMessage.time)), b = u(() => y.value.day - e.Now.plainDateTimeISO().day);
		function x(e) {
			e.selected || (e.selected = !0, v.value = e);
		}
		function S() {
			_.value.forEach((e) => {
				e.selected = !1;
			}), v.value = void 0;
		}
		return h({ reset: S }), (e, n) => (i(), g(p, null, [c("div", M, [c("div", N, [
			c("p", P, f(l.incomingMessage.username), 1),
			c("p", F, f(e.$t("select-conversation.incoming-message-sr", {
				username: l.incomingMessage.username,
				messageDay: b.value,
				messageTime: d(t)(y.value)
			})), 1),
			c("p", I, f(l.incomingMessage.content), 1),
			c("p", L, f(e.$t("select-conversation.message-date", {
				messageDay: b.value,
				messageTime: d(t)(y.value)
			})), 1)
		]), c("div", {
			class: m(["message message--outgoing", { "message--hidden": !v.value }]),
			"aria-hidden": !v.value,
			"aria-live": "polite"
		}, [
			c("p", z, f(l.username), 1),
			c("p", B, f(e.$t("select-conversation.outgoing-message-sr", {
				username: l.username,
				messageDay: 0,
				messageTime: /* @__PURE__ */ new Date()
			})), 1),
			c("div", V, [c("p", H, [c("img", {
				src: v.value?.goodIdea ? d(A) : d(j),
				alt: "",
				width: "16"
			}, null, 8, U), o(" " + f(e.$t(`select-conversation.${v.value?.goodIdea ? "good-idea" : "bad-idea"}`)), 1)]), c("p", W, f(v.value?.content ?? "no content"), 1)]),
			c("p", G, f(e.$t("select-conversation.message-date", {
				messageDay: 0,
				messageTime: /* @__PURE__ */ new Date()
			})), 1)
		], 10, R)]), c("div", K, [
			c("div", {
				role: "heading",
				"aria-level": l.titleLevel,
				class: "title"
			}, f(e.$t("select-conversation.select-response-title", { username: l.username })), 9, q),
			c("div", J, [(i(!0), g(p, null, a(_.value, (e, t) => (i(), g("button", {
				key: t,
				type: "button",
				class: "response-select__choice",
				"aria-disabled": e.selected,
				onClick: (t) => x(e)
			}, f(e.content), 9, Y))), 128))]),
			c("div", X, [v.value ? (i(), g("p", {
				key: 0,
				class: "response-select__feedback",
				innerHTML: v.value.feedback
			}, null, 8, Z)) : s("", !0)])
		])], 64));
	}
}), [["styles", ["html,body,div,span,applet,object,iframe,h1,h2,h3,h4,h5,h6,p,blockquote,pre,a,abbr,acronym,address,big,cite,code,del,dfn,em,img,ins,kbd,q,s,samp,small,strike,strong,sub,sup,tt,var,b,u,i,center,dl,dt,dd,ol,ul,li,fieldset,form,label,legend,table,caption,tbody,tfoot,thead,tr,th,td,article,aside,canvas,details,embed,figure,figcaption,footer,header,hgroup,menu,nav,output,ruby,section,summary,time,mark,audio,video,dialog{font-size:100%;font:inherit;vertical-align:baseline;border:0;margin:0;padding:0}article,aside,details,figcaption,figure,footer,header,hgroup,menu,nav,section{display:block}body{line-height:1}ol,ul{list-style:none}table{border-collapse:collapse;border-spacing:0}.messages,.response-select{--primary-font-size:.875rem;--secondary-font-size:.75rem}*{color:#122647;font-family:Roboto,sans-serif;line-height:normal}.messages{flex-direction:column;gap:8px;padding:16px;display:flex}.message{flex-direction:column;align-items:start;gap:8px;margin-left:0;margin-right:16px;display:flex}.message__username,.message__date{color:#5e6c84;font-size:var(--secondary-font-size);font-weight:400}.message__content{font-size:var(--primary-font-size);background:#e8e8e8;border-radius:8px;padding:16px 8px;font-weight:400}.message--hidden{visibility:hidden}.message--outgoing{align-self:end;align-items:end;margin-left:16px;margin-right:0}.message--outgoing .message__content-container{flex-direction:column;display:flex}.message--outgoing .message__content-title{color:#fff;font-size:var(--secondary-font-size);background:#452d9d;border-radius:8px 8px 0 0;align-self:start;align-items:center;gap:4px;padding:4px 8px;font-weight:700;display:flex}.message--outgoing .message__content-title>img{filter:invert();max-width:16px;max-height:16px}.message--outgoing .message__content{background:#cec3f4;border-top-left-radius:0}.response-select{background-color:#fff;border:1px solid #cdd1d9;border-radius:16px;flex-direction:column;gap:16px;margin-top:25px;padding:24px 16px;display:flex}.response-select__choices{gap:8px;display:flex}.response-select__choice{color:#fff;text-align:center;font-size:var(--primary-font-size);cursor:pointer;background-color:#253858;border-style:none;border-radius:8px;flex:1;padding:8px 16px;font-weight:400;line-height:18px}.response-select__choice[aria-disabled=true]{color:#5e6c84;cursor:not-allowed;background-color:#f4f5f7}.response-select__feedback{color:#122647;font-size:var(--secondary-font-size);background:#eaf1ff;border-radius:8px;padding:8px;font-weight:400;line-height:20px}.title{font-family:Nunito,Roboto,sans-serif;font-size:var(--primary-font-size);font-weight:700}@media (width<=640px){.messages,.response-select{--primary-font-size:.75rem;--secondary-font-size:.688rem}.response-select__choices{flex-direction:column}}.sr-only{clip-path:inset(50%);border:0;width:1px;height:1px;margin:-1px;padding:0;position:absolute;overflow:hidden}"]]]);
//#endregion
//#region src/webcomponents/select-conversation/select-conversation.ce.js
x(/* #__PURE__ */ Object.assign({
	"./locales/de-AT.json": S,
	"./locales/en.json": C,
	"./locales/es-419.json": w,
	"./locales/es.json": T,
	"./locales/fr-BE.json": E,
	"./locales/fr.json": D,
	"./locales/it.json": O,
	"./locales/nl.json": k
})).catch((e) => console.error(e));
var $ = l(Q, { configureApp(e) {
	y.changeLanguage(document?.documentElement?.lang || navigator.language), e.use(b, { i18next: y });
} });
$.prototype.normalizeProps = (e) => ({
	...e,
	titleLevel: v(e.titleLevel)
}), window.customElements.define("select-conversation", $);
//#endregion
